import { ReactNode } from 'react';
import { Box, Stack, Typography } from '@mui/material';

/**
 * The page title and its action buttons.
 *
 * <p>Every screen opens the same way - a capitalised h5 on the left, actions on the
 * right - so the app reads as one product rather than a pile of screens.
 */
const PageHeader = ({ title, subtitle, children }: { title: string; subtitle?: string; children?: ReactNode }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: 2,
      mb: 2,
    }}
  >
    <Box>
      <Typography variant="h5">{title.toUpperCase()}</Typography>
      {subtitle && (
        <Typography variant="caption" color="text.secondary">
          {subtitle}
        </Typography>
      )}
    </Box>
    {children && (
      <Stack direction="row" gap={1} flexWrap="wrap">
        {children}
      </Stack>
    )}
  </Box>
);

export default PageHeader;
